// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-most-consumed-widget',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './most-consumed-widget.component.html',
  styleUrl: './most-consumed-widget.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MostConsumedWidgetComponent {
  @Input() mostConsumedDescription: string = '';
  @Input() units: number = 0;
}
